import { render, staticRenderFns } from "./SlidingTabs.vue?vue&type=template&id=17fe0a2f&scoped=true"
import script from "./SlidingTabs.vue?vue&type=script&lang=js"
export * from "./SlidingTabs.vue?vue&type=script&lang=js"
import style0 from "./SlidingTabs.vue?vue&type=style&index=0&id=17fe0a2f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fe0a2f",
  null
  
)

export default component.exports